// 获取用户信息
export function getUserInfo () {
  return $api.get('/s1/user.getInfo')
}

//  获取手机验证码
export function getMoblieCode (params) {
  return $api.post('/s1/user.sendCode', params)
}

// 绑定手机
export function bindMobile (params) {
  return $api.post('/s1/user.bindMobile', params)
}

// 用户登陆-切换账号
export function userLogin (params) {
  return $api.post('/s1/user.mobileLogin', params)
}

// 微信绑定
export function bindWechat (params) {
  return $api.post('/s1/user.bindWechatAccount', params)
}

// 链接分享
export function shareLink (params) {
  return $api.get('/s1/team.share_info', { params: params })
}
